import * as C from '../common/constants';
import * as ROUTES from '../common/routes';
import CircularProgress from '@mui/material/CircularProgress';
import ContentLayout from './ContentLayout';
import React, { useEffect, useState } from 'react';
import RulesAgreement from './RulesAgreement';
import SurveyForm from './SurveyForm';
import SurveyImage from './SurveyImage';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { fetchData, clearData } from '../common/app/actions';
import { getText } from '../common/utils/helpers';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Share from './Share';
import { useTranslations } from '../common/hooks/useTranslations';

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      centerContainerStyle: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '30vh',
        flex: 1,
      },
      surveyDataStyle: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
      },
      surveyImageStyle: {
        marginTop: '12px',
      },
      surveyContentStyle: {
        width: '100%',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        maxWidth: `${C.SURVEY_MAX_WIDTH}px`,
      },
      shareStyle: {
        width: '100%',
        display: 'flex',
        justifyCOntent: 'flex-end',
        margin: '20px 0',
      },
      [`@media (max-width: 1200px)`]: {
        surveyDataStyle: {
          flexDirection: 'column',
        },
      },
    })
);

const SurveyAdd = (): JSX.Element => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const lng = useSelector((state: any) => state.app.lng);
  const { themeId, surveyId } = useParams();

  const shareText = useTranslations('share_text');

  const [isChecked, setChecked] = useState(false);

  const surveyData = useSelector((state: any) => state.app.surveyData);

  useEffect(() => {
    dispatch(clearData(C.SURVEY_DATA));

    dispatch(fetchData(C.SURVEY_DATA, { themeId, surveyId }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!surveyData) {
    return (
      <div className={classes.centerContainerStyle}>
        <CircularProgress />
      </div>
    );
  }

  const surveyName: string = getText(surveyData?.content, 'text', lng);

  const themeName: string = getText(surveyData?.parent?.content, 'title', lng);
  const themeLabel: string = `Tēma ${themeName?.toUpperCase()}`;
  const rawUri = surveyData?.parent?.content.uri;
  const uri = rawUri.replace('temas/', '/theme/');

  const onRulesCheckboxChange = (checked) => {
    setChecked(checked);
  };

  return (
    <ContentLayout themeTitle={themeLabel} uri={uri}>
      <div className={classes.surveyDataStyle}>
        <div className={classes.surveyImageStyle}>
          <SurveyImage data={surveyData} />
        </div>
        <div className={classes.surveyContentStyle}>
          <SurveyForm data={surveyData} isAgreementChecked={isChecked} />
          <RulesAgreement
            onChange={onRulesCheckboxChange}
            isChecked={isChecked}
          />

          <div className={classes.shareStyle}>
            <Share
              title={surveyName}
              text={shareText || ''}
              url={window.location.href}
            />
          </div>
        </div>
      </div>
    </ContentLayout>
  );
};

export default SurveyAdd;
